import { backendForFirebaseUser } from 'shared/api/backendForFirebaseUser'
import { BackendApiError } from 'shared/api/minecardsBackendClient'
import { loadFirebaseProfile } from './loadFirebaseProfile'
import { normalizeProfileForState } from './normalizeProfileForState'

export const loadCurrentProfile = async (user, nowMs = Date.now()) => {
    const backend = backendForFirebaseUser(user)
    if (!backend) {
        const profile = await loadFirebaseProfile(user, () => new Date(nowMs))
        return normalizeProfileForState(profile, nowMs)
    }

    try {
        const result = await backend.getMe()
        return normalizeProfileForState(result?.profile, nowMs)
    } catch (error) {
        if (!isMissingProfile(error)) {
            throw error
        }
    }

    const result = await backend.initializeProfile()
    return normalizeProfileForState(result?.profile, nowMs)
}

export const loadMinecardsSessionProfile = async (nowMs = Date.now()) => {
    const backend = backendForFirebaseUser(null)
    if (!backend) {
        return null
    }
    const result = await backend.getMe()
    return normalizeProfileForState(result?.profile, nowMs)
}

const isMissingProfile = (error) =>
    error instanceof BackendApiError &&
    error.status === 404 &&
    error.code === 'profile_not_found'
